import Types from '../Types';

// Customer

// Admin
const attemptFindAllPromocodes = (payload = {}) => ({
  type: Types.FIND_ALL_PROMOCODES_ATTEMPT, payload
});
const attemptFindOnePromocode = (payload = {}) => ({
  type: Types.FIND_ONE_PROMOCODE_ATTEMPT, payload
});
const attemptAddPromocode = (payload = {}) => ({
  type: Types.ADD_PROMOCODE_ATTEMPT, payload
});
const attemptSavePromocode = (payload = {}) => ({
  type: Types.SAVE_PROMOCODE_ATTEMPT, payload
});

export default {
  // Admin
  attemptFindAllPromocodes,
  attemptFindOnePromocode,
  attemptAddPromocode,
  attemptSavePromocode
};



/** WEBPACK FOOTER **
 ** ./src/redux/promocode/promocodeActions.js
 **/